import { DataView as DataViews } from 'primereact/dataview';  

const DataView = ({...rest}) => {

    return (
        <DataViews {...rest} />
    )

};

export default DataView;